$(document).ready(function(){
    $(".expiry").numeric({ decimal: false,  negative : false });
    $(".expiry").change(function(){
        $(this).val(function(index, oldVal) { return oldVal.replace(/^0+/, ''); });
    })
})


// WEBPACK FOOTER //
// ./resources/assets/website/scripts/numeric-masking.js